import type { DeepPartial } from '@luna/utils-ts';

import type { ReservationFeatures } from '../../types/ReservationFeatures';
import type { CardReservationFeatures } from '../../types/CardReservationFeatures';

export const reservations: DeepPartial<ReservationFeatures> = {};
export const cards: DeepPartial<CardReservationFeatures> = {};
